module.exports = __webpack_public_path__ + "media/images/social/twitter-brands-dd1db2eb6c658ecc8eb206043a846410.svg";